import PropTypes from "prop-types";
import React from "react";

import Header from "./header";

function Layout({ children }) {
  return (
    <div className="flex flex-col min-h-screen font-sans">
      <Header />
        <main className="bg-gray-100 flex-1 w-full mx-auto">
          {children}
        </main>
      <footer className="bg-gray-100">
        <nav className="border-t-2 border-gray-300 flex justify-center max-w-5xl p-4 mx-auto text-sm md:p-8">
          <p className="text-gray-500 text-lg">
            Made with gatsbyJS © 2021 rabbi.fm
          </p>
        </nav>
      </footer>
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
